/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieVideoGridItemViewModel } from "../types/SerieVideoGridItemViewModel.ts";

export const serieVideoGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do vídeo.")),
  serieId: z.optional(z.number().int().describe("ID da série do vídeo.")),
  date: z.optional(z.string().datetime().describe("Data do vídeo.")),
  thumbnail: z
    .string()
    .describe("Caminho da imagem de capa no storage. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o vídeo está ativo.")),
  langName: z
    .string()
    .describe("Título do vídeo no idioma corrente (ou o primeiro disponível).")
    .nullish(),
}) as unknown as ToZod<SerieVideoGridItemViewModel>;
